import { render } from "./ProposalNeedUpdateModal.vue?vue&type=template&id=a7ef9566"
import script from "./ProposalNeedUpdateModal.vue?vue&type=script&lang=js"
export * from "./ProposalNeedUpdateModal.vue?vue&type=script&lang=js"

import "./ProposalNeedUpdateModal.vue?vue&type=style&index=0&id=a7ef9566&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__